import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useFormContext } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";

const GenderField = () => {
  const { control } = useFormContext();

  return (
    <div className="space-y-4 font-verona">
      <FormField
        control={control}
        name="gender"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Gender *</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                value={field.value}
                className="flex flex-row gap-6"
              >
                <div className="flex items-center space-x-2">
                  <RadioGroupItem
                    value="male"
                    id="male"
                    className="border-2 border-neutral-light text-primary"
                  />
                  <Label
                    htmlFor="male"
                    className="text-sm font-medium text-gray-700 font-verona cursor-pointer"
                  >
                    Male
                  </Label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem
                    value="female"
                    id="female"
                    className="border-2 border-neutral-light text-primary"
                  />
                  <Label
                    htmlFor="female"
                    className="text-sm font-medium text-gray-700 font-verona cursor-pointer"
                  >
                    Female
                  </Label>
                </div>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default GenderField;
